require('./aggCellContextMenu.css');

import VanillaContextMenu from 'vanilla-context-menu';

export const AggCellContextMenu = (scope: HTMLElement, allChildren: (toState?: boolean) => void) =>
  new VanillaContextMenu({
    scope: scope,
    normalizePosition: false,
    customClass: 'context-menu-agg-cell',
    customThemeClass: 'context-menu-theme-agg-cell',
    menuItems: [
      {
        label: 'Select all subsets',
        callback: () => allChildren(true),
        iconHTML: `<i class="fa fa-plus-square"></i>`
      },
      {
        label: 'Clear all subsets',
        callback: () => allChildren(false),
        iconHTML: `<i class="fa fa-minus-square"></i>`
      }
    ]
  });
